import cloneDeep from 'lodash.clonedeep';

type getThemeUtilsOptions = {
  accessibilitySettings: {
    isContrastTheme: boolean;
  };
};
export const CONTRAST_COLOR = '#1C3049';
export const CONTRAST_TEXT_COLOR = '#2A2A2A';
const defaultVal = { accessibilitySettings: { isContrastTheme: false } };
export const getThemeUtils = (utilOptions: getThemeUtilsOptions = defaultVal) => ({
  getOpacity: (isAccessible = true, value = 0.6, options?: any) =>
    isAccessible &&
    utilOptions.accessibilitySettings.isContrastTheme &&
    value < (options?.contrastValue || 0.8)
      ? options?.contrastValue || 0.8
      : value,
  getThemeColors: (originalColors: any) => {
    const colors = cloneDeep(originalColors);
    if (utilOptions.accessibilitySettings?.isContrastTheme) {
      colors.mainColor = CONTRAST_COLOR;
      colors.ctaButtonColor = CONTRAST_COLOR;
      colors.textColor = CONTRAST_TEXT_COLOR;
    }
    return colors;
  },
  getThemeFonts: (originalFonts: any) => {
    const fonts = cloneDeep(originalFonts);
    if (utilOptions.accessibilitySettings?.isContrastTheme && fonts?.normal) {
      fonts.normal.color = CONTRAST_TEXT_COLOR;
    }
    return fonts;
  }
});
